import { ReactNode } from 'react';
import Space from 'antd/lib/space';
import Tag from 'antd/lib/tag';
import Typography from 'antd/lib/typography';
import RobotOutlined from '@ant-design/icons/lib/icons/RobotOutlined';
import { TUpdatableBillField } from 'src/domain/customer-utility-bill/interface';

const { Text } = Typography;

interface Props {
    icon: ReactNode;
    title: string;
    // Fields rendered in this section — the AI marker shows when any of them was AI-extracted for this bill.
    fields: TUpdatableBillField[];
    editableFields: Set<TUpdatableBillField>;
}

// Section title row (icon + title), with a blue "AI-extracted · Verify against PDF" tag pinned to the right corner
// when the section holds AI-extracted fields.
export const BillSectionHeader = ({ icon, title, fields, editableFields }: Props) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <Space>
            {icon}
            <Text strong>{title}</Text>
        </Space>
        {fields.some(field => editableFields.has(field)) && (
            <Tag
                color="blue"
                icon={<RobotOutlined />}
                style={{ margin: 0, marginLeft: 'auto', fontSize: 11, lineHeight: '16px', padding: '0 4px', letterSpacing: 0 }}
            >
                AI-extracted · Verify against PDF
            </Tag>
        )}
    </div>
);
